import { Box, Flex, Grid, Text } from "@chakra-ui/react";
import DataChartSvg from "src/images/data-chart.svg?react";

type Props = { aspectRatio: number };
export const EmptyChart = ({ aspectRatio }: Props) => {
  return (
    <Flex as="figure" direction="column" gap="2" alignItems="center">
      <Grid
        placeContent="start"
        width="100%"
        aspectRatio={aspectRatio}
        gridTemplateColumns="repeat(4, minmax(0, 1fr))"
        gridTemplateRows="repeat(8, minmax(0, 1fr))"
        borderRightWidth="1px"
        borderBottomWidth="1px"
        borderColor="gray.200"
        borderStyle="dashed"
        gap="0"
        position="relative"
      >
        {Array.from({ length: 32 }, (_, i) => (
          <Box
            key={i}
            borderColor="gray.200"
            borderStyle="dashed"
            borderTopWidth="1px"
            borderLeftWidth="1px"
          />
        ))}
        <Box
          position="absolute"
          left="50%"
          top="50%"
          marginLeft="-80px"
          marginTop="-80px"
        >
          <DataChartSvg aria-hidden width="160px" height="160px" />
        </Box>
      </Grid>
      <Text as="figcaption">No data to chart</Text>
    </Flex>
  );
};
